import { z } from "zod/v4"

import { trainingSchema } from "@/lib/auth/models/training"

export const trainingSubject = z.tuple([
  z.union([z.literal("manage"), z.literal("update"), z.literal("delete")]),
  z.union([z.literal("Training"), trainingSchema]),
])

export type TTrainingSubject = z.infer<typeof trainingSubject>
